import React, { useMemo } from "react";
import { IDSInvestigation } from "../models/dsException";
import { AS_INVESTIGATION_WIZARD_STEPS } from "../constants";
import "./dsInvestigationTemplate.css";
interface DSInvestigationTemplateProps {
  investigationValues?: IDSInvestigation;
  osdNumber: number;
  currentDay?: string;
}

const DSInvestigationTemplate: React.FC<DSInvestigationTemplateProps> = ({
  investigationValues,
  osdNumber,
  currentDay,
}: DSInvestigationTemplateProps): JSX.Element => {
  const values = useMemo(() => investigationValues, [investigationValues]);
  const getYesNoValue = (key: keyof IDSInvestigation) => {
    return values?.[key] === "Y" ? "Yes" : "No";
  };

  const renderValues = (key: keyof IDSInvestigation) => {
    const value = values?.[key];
    return (
      <div
        style={{
          width: "75%",
          margin: "0 0 0 0",
          display: "inline-block",
          background: "#f5f7fb",
          padding: "10px",
          border: "1px solid #b5b6b9",
          wordWrap: "break-word",
        }}
      >
        {Array.isArray(value) ? undefined : value}
      </div>
    );
  };

  return (
    <>
      {values && (
        <>
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[0] && (
            <div id="ds-in-day">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 1{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>

              {/* Confirm Delivery Status */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Confirm the delivery status is correct
                </div>
                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("statusCorrect")}
                  </div>
                  {values.statusCorrect === "Y" &&
                    renderValues("statusResponse")}
                </div>
              </div>

              {/* Confirm Delivery Code */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Confirm the delivery code matches the ADE and is populated
                  correctly in the F7
                </div>
                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("deliveryCode")}
                  </div>
                  {values.deliveryCode === "Y" &&
                    renderValues("deliveryCodeResponse")}
                </div>
              </div>

              {/* EP Imaging */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">Are there EP’s in imaging?</div>
                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("epImaging")}
                  </div>
                  {["Y", "N"].includes(values.epImaging ?? "") &&
                    renderValues("epImagingResponse")}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day1F18Note}</div>
                </div>
              </div>
            </div>
          )}

          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[1] && (
            <div id="ds-in-day2">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 2{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Confirm the master shows no movement?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("noMovement")}
                  </div>
                  <br />
                  {values.noMovement === "Y" && (
                    <>
                      <div className="temp-margin-10">
                        Select date of last movement
                      </div>
                      <div className="temp-word-brack">
                        {values.dateLastMovement}
                      </div>{" "}
                      <br />
                    </>
                  )}
                  {values.noMovement === "Y" && values.noMovementSteps && (
                    <>
                      <div className="temp-margin-10">Described steps</div>
                      <div className="temp-word-brack">
                        {values.noMovementSteps}
                      </div>{" "}
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check if a suffix bill or OD400 was cut to move some or all of
                  the freight.
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("suffixBill")}
                  </div>
                  {values.suffixBill === "Y" && renderValues("suffixBillSteps")}
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Did the driver spot the trailer somewhere?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("spotTrailer")}
                  </div>
                  <br />
                  {values.spotTrailer === "Y" && (
                    <>
                      <div className="temp-margin-10">
                        Was freight left on board?
                      </div>
                      <div className="temp-word-brack">
                        {values.freightLeft}
                      </div>{" "}
                      <br />
                    </>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day2F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[2] && (
            <div id="ds-in-day3">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 3{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check the BOL to confirm completion and check for
                  discrepancies
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("bolCheck")}
                  </div>
                  <br />
                  {values.bolCheck === "Y" && (
                    <>
                      <div className="temp-margin-10">
                        Use info on BOL to look for duplicate pros/billing error
                      </div>
                      <div className="temp-word-brack">{values.bolSteps}</div>{" "}
                      <br />
                    </>
                  )}
                  {values.bolCheck === "Y" && values.bolDiscrepancies && (
                    <>
                      <div className="temp-margin-10">
                        List any and all discrepancies
                      </div>
                      <div className="temp-word-brack">
                        {values.bolDiscrepancies}
                      </div>{" "}
                    </>
                  )}
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check the PUM (Pickup manifest) for discrepancies, shipper
                  load and count information, and proper reporting process
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("pumCheck")}
                  </div>
                  {values.pumCheck === "Y" && (
                    <>
                      <div>Pickup Manifest #</div> <br />
                      <div className="temp-word-brack">
                        {values.pumManifest}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.pumCheck === "Y" && (
                    <>
                      <div>List any and all discrepancies: </div> <br />
                      <div className="temp-word-brack">
                        {values.pumDiscrepancy}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Was this a shipper load and count?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("shipperLoad")}
                  </div>
                  <br />
                  <br />
                  {values.shipperLoad === "Y" && (
                    <>
                      <div>
                        Were there any discrepancies? If so, were they properly
                        reported to the shipper?
                      </div>
                      <div className="temp-word-brack">
                        {values.shipperDiscrepancy}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check all linehaul manifests – movement and abnormalities.
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("lineHaulManifest")}
                  </div>
                  {values.lineHaulManifest === "Y" &&
                    renderValues("numbersReview")}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Interview the dock worker(s) about movement abnormalities.
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("interviewWorkers")}
                  </div>
                  {values.interviewWorkers === "Y" &&
                    renderValues("workerSteps")}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  <strong>
                    Call consignee to confirm what was ordered and received (if
                    anything)
                  </strong>
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  ></div>
                  <div>Phone Number: </div> <br />
                  <div className="temp-image-values">
                    {values.consigneePhone}
                  </div>
                  <br />
                  <br />
                  <div>Consignee Name: </div> <br />
                  <div className="temp-image-values">
                    {values.consigneeName}
                  </div>
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Is the consignee still short?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("consigneeShort")}
                  </div>
                  {values.consigneeShort === "Y" && (
                    <>
                      <div>
                        {" "}
                        What are the item numbers received and still missing?{" "}
                      </div>{" "}
                      <br />
                      <div className="temp-word-brack">
                        {values.itemNumbers}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.consigneeShort === "Y" && (
                    <>
                      <div> What was ordered and received for each PO? </div>{" "}
                      <br />
                      <div className="temp-word-brack">
                        {values.orderReceived}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.consigneeShort === "Y" && (
                    <>
                      <div> Was the freight received labeled for them? </div>{" "}
                      <br />
                      <div className="temp-word-brack">
                        {values.freightLabeled}
                      </div>
                      <br />
                      <br />
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  <strong>
                    {" "}
                    Call Shipper to confirm what was shipped, how it was
                    packaged and the value?
                  </strong>
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  ></div>
                  <div> Phone Number: </div> <br />
                  <div className="temp-image-values">{values.shipperPhone}</div>
                  <br />
                  <br />
                  <div> Shipper Name: </div> <br />
                  <div className="temp-image-values">{values.shipperName}</div>
                  <br />
                  <br />
                  <div> What are the details of what shipped? </div> <br />
                  <div className="temp-image-values">
                    {values.shippedDetails}
                  </div>
                  <br />
                  <br /> <div> Was this short shipped? </div> <br />
                  <div className="temp-image-values">{values.shortShipped}</div>
                  <br />
                  <br /> <div> What is the value of the product? </div> <br />
                  <div className="temp-image-values">{values.productValue}</div>
                  <br />
                  <br />{" "}
                  <div>
                    {" "}
                    Were there multiple shipments for the same consignee that
                    day?{" "}
                  </div>{" "}
                  <br />
                  <div className="temp-image-values">
                    {values.multiShipments}
                  </div>
                  <br />
                  <br />
                  <div>
                    {" "}
                    <strong>Call driver about delivery</strong>{" "}
                  </div>{" "}
                  <br />
                  <div> Who did you talk to? </div> <br />
                  <div className="temp-image-values">{values.callDriver}</div>
                  <br />
                  <br />
                  <div>What was delivered? Does it match the ADE?</div>
                  <br />
                  <div className="temp-image-values">{values.adeDelivery}</div>
                  <br />
                  <br />
                  <div> Could the freight be in the nose? </div> <br />
                  <div className="temp-image-values">{values.freightNose}</div>
                  <br />
                  <br />
                  <div>
                    {" "}
                    Was there anything out of the ordinary about this delivery?{" "}
                  </div>{" "}
                  <br />
                  <div className="temp-image-values">
                    {values.outOfOrdinary}
                  </div>
                  <br />
                  <br />
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day3F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[3] && (
            <div id="ds-in-day4">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 4{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check 78/18 and/or Power BI for any overages (OV, NB, DO) to
                  apply
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("check7818")}
                  </div>
                  <div className="temp-image-values">
                    {values.check7818 === "Y" && values.details7818}
                  </div>
                </div>
              </div>
              <div className="temp-cal-width">
                <div> Check cameras at DT and report findings </div> <br />
                {renderValues("cameraFindings")}
              </div>
              <br />
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day4F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[5] && (
            <div id="ds-in-day10">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 10{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Follow up on all leads/request from previous days
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("followUp")}
                  </div>
                  {values.followUp === "Y" && renderValues("followUpDetails")}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day10F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[6] && (
            <div id="ds-in-day15">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 15{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check 78/18 and/or Power BI for any overages (OV, NB, DO) to
                  apply
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("check7818_2")}
                  </div>
                  {values.check7818_2 === "Y" && renderValues("details7818_2")}
                </div>

                <div style={{ margin: "20px 0 10px" }}>
                  Is this high value or high quantity?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("highValue")}
                  </div>
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day15F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {currentDay === AS_INVESTIGATION_WIZARD_STEPS[7] && (
            <div id="ds-in-day20">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  Delivered Short Investigation Day 20{" "}
                  <span className="temp-osd">#{osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Final re-check of all leads/requests/overages to confirm the
                  freight cannot be located at this time
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {getYesNoValue("finalReCheck")}
                  </div>
                  {values.finalReCheck === "Y" &&
                    renderValues("detailsOfSearch")}
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day20F18Note}</div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default DSInvestigationTemplate;
